// Wordless loading indicator: a static gold seal. Used by the boot veil
// (App.js) and the 3D viewer's "loading model" states (App.js,
// ViewerShell.jsx), which previously showed separate text-based indicators
// ("Loading...", "Loading Model").
//
// `size` is any CSS length: a number for a fixed px box, or a string when it
// needs to respond to the viewport — the boot veil passes a min() so the
// seal fits narrow phone screens without shrinking on desktop.
export default function SealLoader({ size = 56, color }) {
  return (
    <div role="status" aria-live="polite" aria-label="Loading">
      <div
        aria-hidden="true"
        style={{
          width: size,
          height: size,
          backgroundColor: color,
          WebkitMaskImage: "url(/seal.svg)",
          maskImage: "url(/seal.svg)",
          WebkitMaskSize: "contain",
          maskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskPosition: "center",
        }}
      />
    </div>
  );
}
